const {
    GET_ALL_BONG_REQUEST,
    GET_ALL_BONG_SUCCESS,
    GET_ALL_BONG_FAIL,
    ADD_BONG_REQUEST,
    ADD_BONG_SUCCESS,
    ADD_BONG_FAIL,
    GET_BONG_REQUEST,
    GET_BONG_SUCCESS,
    GET_BONG_FAIL,
    UPDATE_BONG_REQUEST,
    UPDATE_BONG_SUCCESS,
    UPDATE_BONG_FAIL,
    DELETE_BONG_REQUEST,
    DELETE_BONG_SUCCESS,
    DELETE_BONG_FAIL,
    ADD_BNARTICLE_REQUEST,
    ADD_BNARTICLE_SUCCESS,
    ADD_BNARTICLE_FAIL,
    UPDATE_BNARTICLE_REQUEST,
    UPDATE_BNARTICLE_SUCCESS,
    UPDATE_BNARTICLE_FAIL,
    DELETE_BNARTICLE_REQUEST,
    DELETE_BNARTICLE_SUCCESS,
    DELETE_BNARTICLE_FAIL
} = require("../../actionTypes/Vente/BonG");

  
  function getAllBonG(state = { data: {} }, action) {
    switch (action.type) {
      case GET_ALL_BONG_REQUEST:
        return { loading: true, data: {} };
      case GET_ALL_BONG_SUCCESS:
        return { loading: false, data: action.payload };
      case GET_ALL_BONG_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function getBonG(state = { data: {} }, action) {
    switch (action.type) {
      case GET_BONG_REQUEST:
        return { loading: true, data: {} };
      case GET_BONG_SUCCESS:
        return { loading: false, data: action.payload };
      case GET_BONG_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function addBonG(state = { data: {} }, action) {
    switch (action.type) {
      case ADD_BONG_REQUEST:
        return { loading: true, data: {} };
      case ADD_BONG_SUCCESS:
        return { loading: false, data: action.payload };
      case ADD_BONG_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function updateBonG(state = { data: {} }, action) {
    switch (action.type) {
      case UPDATE_BONG_REQUEST:
        return { loading: true, data: {} };
      case UPDATE_BONG_SUCCESS:
        return { loading: false, data: action.payload };
      case UPDATE_BONG_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function deleteBonG(state = { data: {} }, action) {
    switch (action.type) {
      case DELETE_BONG_REQUEST:
        return { loading: true, data: {} };
      case DELETE_BONG_SUCCESS:
        return { loading: false, data: action.payload };
      case DELETE_BONG_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function addBNArticle(state = { data: {} }, action) {
    switch (action.type) {
      case ADD_BNARTICLE_REQUEST:
        return { loading: true, data: {} };
      case ADD_BNARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case ADD_BNARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function updateBNArticle(state = { data: {} }, action) {
    switch (action.type) {
      case UPDATE_BNARTICLE_REQUEST:
        return { loading: true, data: {} };
      case UPDATE_BNARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case UPDATE_BNARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function deleteBNArticle(state = { data: {} }, action) {
    switch (action.type) {
      case DELETE_BNARTICLE_REQUEST:
        return { loading: true, data: {} };
      case DELETE_BNARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case DELETE_BNARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  export {
    addBonG,
    getBonG,
    updateBonG,
    deleteBonG,
    getAllBonG,
    addBNArticle,
    updateBNArticle,
    deleteBNArticle
  };
  